/**
 * The merchant of record behind every sale, shown before payment. Mirrors
 * server/src/lib/merchant.ts, which prints the same on receipts — keep in step.
 * The address is translated, so it comes from home.contact.address.
 */
export const MERCHANT = {
  legalName: "MEDIA STYLE 25 EOOD",
  tradingName: "MEDIA-STYLE",
  uic: "208512111",
  website: "https://aistylemedia.com",
  email: "Info@aistylemedia.com",
  phone: "+359 886 886 479",
} as const;
